import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import afterHoursLogo from "../../../assets/images/after_hours_icon.svg";
import CommonHeader from "../../../components/elements/CommonHeader";
import ROUTE_PATHS from "../../../utils/routePaths";

const AfterHoursHeader = () => {
  const { tripId } = useParams();
  const location = useLocation();

  // Get values from localStorage if not in location state
  const currentPage =
    location?.state?.currentPage || localStorage.getItem("currentPage");
  const fromScreen =
    location?.state?.fromScreen || localStorage.getItem("fromScreen");

  return (
    <CommonHeader
      centerLogoSrc={afterHoursLogo}
      headerText="After Hours Approval"
      backContent={
        <div className="navigation-header">
          <Link
            to={
              fromScreen === "notifications"
                ? ROUTE_PATHS.NOTIFICATIONS_PAGE
                : ROUTE_PATHS.TRIP_REQUEST_PAGE
            }
            state={
              fromScreen === "notifications"
                ? { currentPage, fromNotifications: true }
                : { currentPage }
            }
            className="navigation-header-link"
          >
            Home/
          </Link>
          <Link
            to={
              fromScreen === "tripDetails"
                ? ROUTE_PATHS.TRIP_DETAILS(tripId)
                : ROUTE_PATHS.HISTORIC_TRIP_DETAILS(tripId)
            }
            state={{ currentPage }}
            className="navigation-header-link"
          >
            {fromScreen === "tripDetails" ? "Trip Requests/" : "Historic Trips/"}
          </Link>
          After Hours Approval
        </div>
      }
    />
  );
};

export default AfterHoursHeader;
